module.exports = __webpack_public_path__ + "static/media/12-3.05feff92.mp3";